import React from 'react';

import { useSite } from '../../hooks/use-site';
import PrivacyPolicyDE from './self-co/privacy-policy/de';
import PrivacyPolicyEN from './self-co/privacy-policy/en';

export default function TextPrivacyPolicy() {
  const { locale } = useSite();

  return locale === 'en' ? <PrivacyPolicyEN /> : <PrivacyPolicyDE />;
}
